import { connect } from 'react-redux';

import { closeBanner } from '../actions/appBanner';
import { calcIsVisible } from '../utils';

import AppBanner from '../components/AppBanner';

export default connect(
  (state, ownProps) => ({
    isVisible: calcIsVisible(state.user.mobileAppBanner, ownProps.location),
  }),
  {
    onCloseClick: closeBanner,
  }
)(AppBanner);
